import { render, staticRenderFns } from "./ConsignContractChooseDialog.vue?vue&type=template&id=2dd4bb8c&scoped=true"
import script from "./ConsignContractChooseDialog.vue?vue&type=script&lang=js"
export * from "./ConsignContractChooseDialog.vue?vue&type=script&lang=js"
import style0 from "./ConsignContractChooseDialog.vue?vue&type=style&index=0&id=2dd4bb8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd4bb8c",
  null
  
)

export default component.exports